<template lang="html">
  <div
    class="users-list"
    v-if="isAdmin">
    <div class="card">
      <div class="card-header">
        <h3 class="text-nowrap">Listagem de usuários</h3>
        <div class="w-100">
          <font
            class="float-right"
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
      <div class="card-body">
        <div
          v-if="error"
          class="alert alert-danger text-center"
          role="alert">
          <span v-html="error.message" />
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 d-flex">
            <div class="input-group per-page">
              <div class="input-group-prepend">
                <button
                  disabled
                  class="input-group-text">por página</button>
              </div>
              <select
                class="custom-select custom-select-sm form-control form-control-sm perPage"
                id="perPage"
                v-model="perPage">
                <option
                  v-for="option in pageOptions"
                  :key="option"
                  :value="option">
                  {{ option }}
                </option>
              </select>
            </div>
            <div class="ml-auto">
              <users-new />
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="input-group filter ml-auto filter-list">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Buscar por"
                aria-label="Buscar por"
                v-model="filter">
              <div class="input-group-append">
                <button
                  :disabled="!filter"
                  @click="filter = ''"
                  class="input-group-text">Limpar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-table text-left">
          <b-table
            class="table"
            show-empty
            striped
            hover
            small
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered">
            <template
              slot="role"
              slot-scope="row">
              <span>{{ row.item.role === 'ADMIN' ? 'Administrador' : 'Usuário' }}</span>
            </template>
            <template
              slot="emailVerified"
              slot-scope="row">
              <span>{{ row.item.emailVerified === true ? 'Ativo' : 'Bloqueado' }}</span>
            </template>
            <template
              slot="details"
              slot-scope="row">
              <span class="buttons">
                <a
                  class="btn btn-sm btn-danger"
                  @click="showConfirmInactive(row.item)"
                  v-if="showInactiveButton(row.item)">
                  Bloquear
                </a>
                <a
                  class="btn btn-sm btn-primary"
                  @click="showConfirmActive(row.item)"
                  v-if="showActiveButton(row.item)">
                  Desbloquear
                </a>
                <a
                  type="button"
                  class="btn btn-outline-secondary"
                  @click.prevent="showChangeAccessType(row.item)"
                  v-if="showChangeAccessTypeButton(row.item)">
                  Alterar Acesso
                </a>
              </span>
            </template>
          </b-table>
        </div>
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          :limit="10" />
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      ref="confirmInactive"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Você tem certeza?</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger"
              role="alert">
              Você tem certeza que deseja bloquear o usuário {{ getEmailFromUser(userToInactive) }}?
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="inactiveUser">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      ref="confirmActive"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Você tem certeza?</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-primary"
              role="alert">
              Você tem certeza que deseja desbloquear o usuário?
            </div>
            <div
              class="alert alert-warning"
              role="alert">
              Atenção! Para completar o desbloqueio o usuário precisa acessar o <b>link de confirmação</b> que foi enviado para o email {{ getEmailFromUser(userToActive) }}
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="activeUser">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      ref="confirmChangeAccessType"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Alterar Tipo de Acesso</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Você tem certeza que deseja alterar o Tipo de Acesso do usuário
              <strong>{{ getEmailFromUser(userToChangeAccessType) }}</strong>
              para
              <strong>{{ getInvertRoleName(userToChangeAccessType) }}</strong>
              ?
            </p>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="changeAccessType">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialManagerUsers"
      ref="tutorialManagerUsers"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Gerenciar Usuários</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/ENjBxsvyTak"
              title="Tutorial Gerenciar Usuários"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import UsersNew from '@/components/Users/New.vue'
import { EventBus } from '@/services/event-bus'

export default {
  name: 'UsersList',
  components: {
    UsersNew
  },
  props: {
    newUser: {
      default: _ => {},
      type: Object
    }
  },
  data () {
    return {
      error: null,
      perPage: 10,
      pageOptions: [10, 25, 50],
      currentPage: 1,
      totalRows: 1,
      filter: null,
      userToActive: null,
      userToInactive: null,
      userToChangeAccessType: null,
      fields: {
        name: {
          label: 'Nome',
          sortable: true,
          class: 'header-name'
        },
        email: {
          label: 'Email',
          sortable: true,
          class: 'header-email'
        },
        phone: {
          label: 'Telefone',
          sortable: true,
          class: 'header-phone'
        },
        role: {
          label: 'Acesso',
          sortable: true,
          class: 'header-role'
        },
        emailVerified: {
          label: 'Ativo',
          sortable: true,
          class: 'header-active'
        },
        details: {
          label: 'ações',
          sortable: false,
          thClass: 'text-right header-actions',
          tdClass: 'text-right'
        }
      },
      items: null,
      isActionsBlocked: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getUsers()
      EventBus.$on('new-user-added', newUser => {
        if (newUser) {
          this.items.push(newUser)
          this.totalRows = this.items.length
        }
      })
    })
  },
  methods: {
    getUsers () {
      loopback
        .get(`/users?filter[order]=name asc`)
        .then(users => {
          if (users) {
            this.items = users
            this.totalRows = this.items.length
          }
        })
        .catch((err) => {
          this.error = err
        })
    },
    showConfirmActive (user) {
      if (user && !this.isActionsBlocked) {
        this.userToActive = user
        $(this.$refs.confirmActive).modal('show')
      }
    },
    activeUser () {
      this.isActionsBlocked = true
      const emailToActive = this.userToActive.email
      loopback
        .patch('/users', {
          email: emailToActive,
          emailVerified: 'true'
        })
        .then(user => {
          if (user) {
            this.items = this.items.map(function (ele) {
              if (ele.email === emailToActive) {
                return user
              } else {
                return ele
              }
            })
            this.totalRows = this.items.length
            $(this.$refs.confirmActive).modal('hide')
          }
          this.reactiveActions()
        })
        .catch((err) => {
          $(this.$refs.confirmActive).modal('hide')
          this.error = err
          this.reactiveActions()
        })
    },
    showConfirmInactive (user) {
      if (user && !this.isActionsBlocked) {
        this.userToInactive = user
        $(this.$refs.confirmInactive).modal('show')
      }
    },
    inactiveUser () {
      this.isActionsBlocked = true
      const emailToInactive = this.userToInactive.email
      loopback
        .patch('/users', {
          email: emailToInactive,
          emailVerified: 'false'
        })
        .then(user => {
          if (user) {
            this.items = this.items.map(function (ele) {
              if (ele.email === emailToInactive) {
                return user
              } else {
                return ele
              }
            })
            this.totalRows = this.items.length
            $(this.$refs.confirmInactive).modal('hide')
          }
          this.reactiveActions()
        })
        .catch((err) => {
          $(this.$refs.confirmInactive).modal('hide')
          this.error = err
          this.reactiveActions()
        })
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    showActiveButton (user) {
      if (this.$store.state.auth.user && user.email === this.$store.state.auth.user.email) return false
      return user.emailVerified !== true
    },
    showInactiveButton (user) {
      if (this.$store.state.auth.user && user.email === this.$store.state.auth.user.email) return false
      return user.emailVerified === true
    },
    showChangeAccessTypeButton (user) {
      if (this.$store.state.auth.user && user.email === this.$store.state.auth.user.email) return false
      return true
    },
    showChangeAccessType (user) {
      if (user) {
        this.userToChangeAccessType = user
        $(this.$refs.confirmChangeAccessType).modal('show')
      }
    },
    changeAccessType () {
      const emailToChangeAccessType = this.userToChangeAccessType.email
      loopback
        .patch('/users', {
          email: emailToChangeAccessType,
          role: this.userToChangeAccessType.role === 'ADMIN' ? 'USER' : 'ADMIN'
        })
        .then(user => {
          if (user) {
            this.items = this.items.map(function (ele) {
              if (ele.email === emailToChangeAccessType) {
                return user
              } else {
                return ele
              }
            })
            this.totalRows = this.items.length
            $(this.$refs.confirmChangeAccessType).modal('hide')
          }
        })
        .catch((err) => {
          $(this.$refs.confirmChangeAccessType).modal('hide')
          this.error = err
        })
    },
    getEmailFromUser (user) {
      if (user && user.email) return user.email
    },
    getInvertRoleName (user) {
      if (user && user.role) return user.role === 'ADMIN' ? 'Usuário' : 'Administrador'
    },
    openTutorial () {
      $(this.$refs.tutorialManagerUsers).modal('show')
    },
    reactiveActions () {
      setTimeout(() => {
        this.isActionsBlocked = false
      }, 5000)
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Users/List.vue